require('./depositRenovationCancelStep1.scss')

//@vendors
const React = require('react');
const PropTypes = require('prop-types');

// @core
const { FormattedText } = require('core/i18n').i18n;

// @components
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');

// @constants
const { DATE_FORMAT_WITH_DASHES } = require('constants/index');
const { formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper')
import { INTERVENER_CODES } from 'constants/interveners'
// @helpers
const { getFullName } = require('utilities/personalDataHelper');
const dateHelper = require('utilities/dateHelper');
const { formatInterest } = require('utilities/currencyHelper');
const { getIsFullProfitability } = require('utilities/depositHelper')

class DepositRenovationCancelStep1 extends React.Component {
    constructor(props) {
        super(props);
        this.renderInfoBlock = this.renderInfoBlock.bind(this);
    }

    renderInfoBlock = () => {
        const { immDepositRenovationCancel, immProfile, immDeposit, originCountry } = this.props
        const renovation = immDepositRenovationCancel.toJS()

        return renovation.originalImpositions.map(imposition => {
            const clientFullName = getFullName(immProfile);
            const requestDate = dateHelper.formatDate(imposition.requestDate, DATE_FORMAT_WITH_DASHES);
            const expirationDate = dateHelper.formatDate(imposition.originalImpositionExpirationDate, DATE_FORMAT_WITH_DASHES);
            const tae = formatInterest(imposition.renewalTae)
            const tin = formatInterest(imposition.renewalTin)
            const showFullValues = getIsFullProfitability(originCountry)
            const months = renovation.renewalDepositTermValue

            const isSameTinTae = tin === tae

            const plainAmountObject = getPlainAmountObject({
                amount: imposition.renewalAmount,
                currency: immDeposit.getIn(['amount', 'currency'])
            });

            const { amount, currencySymbol } = formatAmountObject(plainAmountObject, true)
            const fullAmount = `${amount} ${currencySymbol}`

            const depositContractNumber = immDeposit.getIn([ 'contract', 'fullContractNumber' ]).trim()
            const impositionNumber = imposition.originalImpositionNumber

            const holders = imposition.depositRenewalInterveners
                .filter(intervener => INTERVENER_CODES.holder === intervener.intervenerInterventionType)
                .map(intervener => intervener.intervenerName.trim())
                .join(', ');

            const injectedStrings = [
                requestDate,
                months,
                fullAmount,
                expirationDate,
                ...(showFullValues && !isSameTinTae ? tae : []),
                tin,
                depositContractNumber,
                holders,
                clientFullName
            ];

            const depositFullInformation = isSameTinTae
                ? "contractsView-contractsView_depositRenovationCancelconfirmationSameTinTaeText2"
                : "contractsView-contractsView_depositRenovationCancelconfirmationText2" 

            const informationKey = showFullValues
                ? depositFullInformation
                : "contractsView-contractsView_depositRenovationCancelconfirmationText2Simple"

            return (
                <p key={impositionNumber} className="deposits-renovations-cancel__disclaimer-text">
                    <FormattedText value={informationKey} injectedStrings={injectedStrings} />
                </p>
            )
        })
    }

    renderAction(textTranslate, isQuestion = false) {
        const { immProfile } = this.props
        const clientFullName = getFullName(immProfile);
        return (
            <p>
                <FormattedText value={textTranslate} /> <strong>{clientFullName}</strong>{ isQuestion && '?' }
            </p>
        )
    }

    render() {
        let content;

        content = (
            <div className="deposits-renovations-cancel-step1">
                <h4 className="deposits-renovations-cancel-step1__title wizard-step--vertical__title">
                    <FormattedText value="contractsView-contractsView_depositRenovationCancelTitle" />
                </h4>
                <div className="deposits-renovations-cancel-step1__main-content">
                    <div className="deposits-renovations-cancel-step1__subtitle no-print-out">
                        <FormattedText value="cancelImposition-confirmationSubtitle" />
                    </div>
                    <BlockInfo extraClass="deposits-renovations-cancel-step1__disclaimer-box">
                        { this.renderAction("contractsView-contractsView_depositRenovationCancelconfirmationText1") }
                        { this.renderInfoBlock() }
                        { this.renderAction("contractsView-contractsView_depositRenovationCancelconfirmationText3", true) }
                    </BlockInfo>
                </div>
            </div>
        );

        return content;
    }
}

DepositRenovationCancelStep1.propTypes = {
    immProfile: PropTypes.object.isRequired,
    immDepositRenovationCancel: PropTypes.object.isRequired,
    immDeposit: PropTypes.object,
    impositionId: PropTypes.string.isRequired,
    originCountry: PropTypes.string.isRequired,
};

module.exports = DepositRenovationCancelStep1;
